import "core-js/modules/es.array.push.js";
import axios from "axios";
import moment from "moment";
import * as echarts from "echarts";
import randomColor from "randomcolor";
import * as XLSX from "xlsx";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      username: "",
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      userIsConsultant: false,
      consultantId: "",
      zoom: sessionStorage.getItem("zoom") || 1,
      dateRange: [],
      paymentRecords: [],
      oriPaymentRecords: [],
      // 顾问业绩记录
      consultantPay: {},
      consultantRealPayTotal: {},
      consultantPayTotal: {},
      consultantRefund: {},
      consultantRefundTotal: {},
      consultantRefundServiceFeeTotal: {},
      consultantRefundRealTotal: {},
      consultantAttendFee: {},
      consultantAttendFeeTotal: {},
      consultantAttendFeeSummary: {},
      consultantUnattendFee: {},
      consultantUnattendFeeSummary: {},
      consultantBalance: {},
      consultantUnattendLoading: false,
      consultantUnattendError: "",
      // 全部时间的业绩
      selectAllTime: false,
      allTimePerformance: {},
      // 顾问业绩排名
      consultantPerformance: {},
      consultantPerformanceRank: {},
      // 顾问列表
      consultantList: [],
      consultantNames: {},
      selectedConsultantIndex: -1,
      //
      selectedMonth: "",
      colors: ["#152c7c", "#2e74ba", "#a2c0e6", "#dae1e9", "#019072", "#17b5d0", "#07aa6b", "#006ab6", "#c4dfb9", "#95a06a"],
      performancePercentage: [],
      searchStr: ""
    };
  },
  async mounted() {
    const loading = ElLoading.service({
      lock: true,
      text: "处理中...",
      background: "rgba(0, 0, 0, 0.7)"
    });
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const logStep = label => {
      const t = performance.now();
      console.log(`[paymentRecords mounted] ${label}: ${(t - stepT0).toFixed(1)}ms`);
      stepT0 = t;
    };
    this.username = this.userInfo.name;
    logStep("设置 username");

    // 日期范围默认当月
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    this.dateRange = [startOfMonth, endOfMonth];
    logStep("初始化 dateRange(当月)");

    // 顾问业绩，选择的月份默认当前月
    this.selectedMonth = moment().format("YYYY-MM");
    logStep("初始化 selectedMonth(当月)");

    // 四个首屏请求互不依赖，并行执行，避免接口耗时串行累加。
    await Promise.all([this.userIfConsultant(false), this.getPaymentRecords(false), this.getConsultantList(false), this.getConsultantPerformance(false, false)]);
    logStep("并行加载顾问身份、交易记录、顾问列表和月度业绩");

    // 得到顾问index
    if (this.userIsConsultant) {
      this.selectedConsultantIndex = this.consultantList.findIndex(consultant => consultant.id === this.consultantId);
    }
    logStep("计算 selectedConsultantIndex(若为顾问)");
    if (this.userIsConsultant) {
      this.loadConsultantUnattendAmount();
      logStep("开始后台加载未消课时金额");
    }
    await this.$nextTick();
    await this.drawChart1();
    logStep("drawChart1");
    loading.close();
    console.log(`[paymentRecords mounted] 总用时: ${(performance.now() - mountT0).toFixed(1)}ms`);
  },
  methods: {
    // 未消金额单独显示 loading，不阻塞交易记录和月度业绩首屏展示。
    async loadConsultantUnattendAmount() {
      this.consultantUnattendLoading = true;
      this.consultantUnattendError = "";
      try {
        await this.getConsultantDateRange(false);
        await this.getConsultantPerformance(true, false);
      } catch (error) {
        console.error("加载未消课时金额失败:", error);
        this.consultantUnattendError = "金额加载失败";
      } finally {
        this.consultantUnattendLoading = false;
      }
    },
    // 判断登录的用户是否是顾问
    async userIfConsultant(showLoading = true) {
      //loading界面
      const loading = showLoading ? ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      }) : null;
      try {
        let params = {
          institution: this.institution,
          phone: this.userInfo.phone
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/paymentRecords/userIfConsultant", params);
        if (resp1.data.code == "0000") {
          this.consultantId = resp1.data.data;
          if (this.consultantId != 0) {
            this.userIsConsultant = true;
          }
          console.log("this.userIsConsultant:", this.userIsConsultant);
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:" + error);
        alert("catch error: " + error);
      } finally {
        if (loading) {
          loading.close();
        }
      }
    },
    // 获取交费记录
    async getPaymentRecords(showLoading = true) {
      //loading界面
      const loading = showLoading ? ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      }) : null;
      try {
        let params = {
          dateRange: this.dateRange,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/paymentRecords/getPaymentRecords", params);
        if (resp1.data.code == "0000") {
          this.paymentRecords = resp1.data.data;

          // console.log("this.paymentRecords:", this.paymentRecords);

          this.oriPaymentRecords = JSON.parse(JSON.stringify(this.paymentRecords));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:" + error);
        alert("catch error: " + error);
      } finally {
        if (loading) {
          loading.close();
        }
      }
    },
    // 获取顾问业绩
    async getConsultantPerformance(selectAllTime, showLoading = true) {
      //loading界面
      const loading = showLoading ? ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      }) : null;
      try {
        let dateRange = [];
        let requestUrl = "https://backend.wonology.com/finance/consultantPerformance/getConsultantPerformance";

        // 如果是全部时间
        if (selectAllTime) {
          // 获取顾问全部时间的日期范围
          if (this.consultantList[this.selectedConsultantIndex]) {
            dateRange = this.consultantDateRange[this.consultantList[this.selectedConsultantIndex].id];
          }

          // 有些顾问，没有全部时间的日期范围
          if (!dateRange || !dateRange[0]) {
            dateRange = [];
            dateRange[0] = moment().format("YYYY-MM-DD");
            dateRange[1] = moment().format("YYYY-MM-DD");
          }
        }
        // 如果不是全部时间，则用选择的月份的开始和结束日期作为日期范围
        else {
          requestUrl = "https://backend.wonology.com/finance/consultantPerformance/getConsultantPerformanceSummary";
          let startDate = moment(this.selectedMonth).format("YYYY-MM-DD");
          let endDate = moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD");
          dateRange = [startDate, endDate];
        }
        // console.log("dateRange:", dateRange);

        let params = {
          institution: this.institution,
          dateRange: dateRange
        };
        let resp1 = await axios.post(requestUrl, params);
        if (resp1.data.code == "0000") {
          if (!selectAllTime) {
            this.consultantPerformance = resp1.data.data.consultantPerformance || {};
            this.consultantRealPayTotal = resp1.data.data.consultantRealPayTotal || {};
            this.consultantRefundTotal = resp1.data.data.consultantRefundTotal || {};
            return;
          }

          // console.log("顾问业绩resp1.data.data:", resp1.data.data);

          // 全部时间业绩
          if (selectAllTime) {
            this.allTimePerformance = resp1.data.data;

            ///////////////////
            // 交易记录
            this.allTimePerformance.consultantRealPayTotal = {};
            this.allTimePerformance.consultantPayTotal = {};
            for (let consultantId in this.allTimePerformance.consultantPay) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantPay[consultantId]) {
                total += this.allTimePerformance.consultantPay[consultantId][i].amount;
              }
              this.allTimePerformance.consultantPayTotal[consultantId] = total;
              total = 0;
              for (let i in this.allTimePerformance.consultantPay[consultantId]) {
                // 如果有 real_prepay 字段，则用 real_prepay 计算总额
                if (this.allTimePerformance.consultantPay[consultantId][i].real_prepay) {
                  total += this.allTimePerformance.consultantPay[consultantId][i].real_prepay;
                }
                // 否则用 amount 计算总额
                else {
                  total += this.allTimePerformance.consultantPay[consultantId][i].amount;
                }
              }
              this.allTimePerformance.consultantRealPayTotal[consultantId] = total;
            }

            ///////////////////
            // 退费记录

            ///////////////////
            // 已消记录
            this.allTimePerformance.consultantAttendFeeTotal = {};
            for (let consultantId in this.allTimePerformance.consultantAttendFee) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantAttendFee[consultantId]) {
                total += this.allTimePerformance.consultantAttendFee[consultantId][i].amount;
              }
              this.allTimePerformance.consultantAttendFeeTotal[consultantId] = total;
            }

            ///////////////////
            // 未消记录
            this.allTimePerformance.consultantUnattendFeeTotal = {};
            for (let consultantId in this.allTimePerformance.consultantUnattendFee) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantUnattendFee[consultantId]) {
                total += this.allTimePerformance.consultantUnattendFee[consultantId][i].amount;
              }

              // 未消金额合计，还要加余额剩余
              if (this.allTimePerformance.consultantBalance[consultantId]) {
                for (let studentId in this.allTimePerformance.consultantBalance[consultantId]) {
                  total += this.allTimePerformance.consultantBalance[consultantId][studentId];
                }
              }
              this.allTimePerformance.consultantUnattendFeeTotal[consultantId] = total;
            }
          }
          // 非全部时间, 指定日期范围
          else {
            ///////////////////
            // 交易记录
            this.consultantPay = resp1.data.data.consultantPay;
            this.consultantRealPayTotal = {};
            this.consultantPayTotal = {};
            for (let consultantId in this.consultantPay) {
              let total = 0;
              for (let i in this.consultantPay[consultantId]) {
                total += this.consultantPay[consultantId][i].amount;
              }
              this.consultantPayTotal[consultantId] = total;
              total = 0;
              for (let i in this.consultantPay[consultantId]) {
                // 如果有 real_prepay 字段，则用 real_prepay 计算总额
                if (this.consultantPay[consultantId][i].real_prepay) {
                  total += this.consultantPay[consultantId][i].real_prepay;
                }
                // 否则用 amount 计算总额
                else {
                  total += this.consultantPay[consultantId][i].amount;
                }
              }
              this.consultantRealPayTotal[consultantId] = total;
            }

            ///////////////////
            // 退费记录
            this.consultantRefund = resp1.data.data.consultantRefund;
            this.consultantRefundTotal = {};
            this.consultantRefundServiceFeeTotal = {};
            this.consultantRefundRealTotal = {};
            for (let consultantId in this.consultantRefund) {
              if (!this.consultantRefundTotal[consultantId]) {
                this.consultantRefundTotal[consultantId] = 0;
              }
              if (!this.consultantRefundServiceFeeTotal[consultantId]) {
                this.consultantRefundServiceFeeTotal[consultantId] = 0;
              }
              if (!this.consultantRefundRealTotal[consultantId]) {
                this.consultantRefundRealTotal[consultantId] = 0;
              }
              for (let i in this.consultantRefund[consultantId]) {
                this.consultantRefundTotal[consultantId] += this.consultantRefund[consultantId][i].refundFee;
                this.consultantRefundServiceFeeTotal[consultantId] += this.consultantRefund[consultantId][i].refundServiceFee;
                this.consultantRefundRealTotal[consultantId] += this.consultantRefund[consultantId][i].refundRealFee;
              }
            }
            // console.log(
            //   "this.consultantRefundTotal:",
            //   this.consultantRefundTotal
            // );

            // 顾问业绩 = 实际缴费 - 退费
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;
              if (!this.consultantRealPayTotal[consultantId]) {
                this.consultantRealPayTotal[consultantId] = 0;
              }
              if (!this.consultantRefundTotal[consultantId]) {
                this.consultantRefundTotal[consultantId] = 0;
              }
              this.consultantPerformance[consultantId] = this.consultantRealPayTotal[consultantId] - this.consultantRefundTotal[consultantId];
            }

            // 顾问业绩排名
            this.consultantPerformanceRank = {};
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;

              // 如果顾问没业绩，赋值0
              if (!this.consultantPerformance[consultantId]) {
                this.consultantPerformance[consultantId] = 0;
              }
              this.consultantPerformanceRank[consultantId] = 1;
              for (let consultantId_2 in this.consultantPerformance) {
                // 每有一个顾问比自己业绩高，排名变大1
                if (this.consultantPerformance[consultantId] < this.consultantPerformance[consultantId_2]) {
                  this.consultantPerformanceRank[consultantId] += 1;
                }
              }
            }

            ///////////////////
            // 已消金额
            this.consultantAttendFee = resp1.data.data.consultantAttendFee;
            this.consultantAttendFeeTotal = {};
            for (let consultantId in this.consultantAttendFee) {
              let total = 0;
              for (let i in this.consultantAttendFee[consultantId]) {
                total += this.consultantAttendFee[consultantId][i].amount;
              }
              this.consultantAttendFeeTotal[consultantId] = total;
            }
            this.consultantBalance = resp1.data.data.consultantBalance;

            ///////////////////
            // 未消金额
            this.consultantUnattendFee = resp1.data.data.consultantUnattendFee;
            this.consultantUnattendFeeTotal = {};
            for (let consultantId in this.consultantUnattendFee) {
              let total = 0;
              for (let i in this.consultantUnattendFee[consultantId]) {
                total += this.consultantUnattendFee[consultantId][i].amount;
              }
              if (this.consultantBalance[consultantId]) {
                for (let studentId in this.consultantBalance[consultantId]) {
                  total += this.consultantBalance[consultantId][studentId];
                }
              }
              this.consultantUnattendFeeTotal[consultantId] = total;
            }
            this.consultantAttendFeeSummary = resp1.data.data.consultantAttendFeeSummary;
            this.consultantUnattendFeeSummary = resp1.data.data.consultantUnattendFeeSummary;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        if (loading) {
          loading.close();
        }
      }
    },
    // 获取顾问列表
    async getConsultantList(showLoading = true) {
      //loading界面
      const loading = showLoading ? ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      }) : null;
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/getSalesPerson", params);
        if (resp1.data.code == "0000") {
          this.consultantList = resp1.data.data;
          this.consultantNames = {};
          for (let i = 0; i < this.consultantList.length; i++) {
            this.consultantNames[this.consultantList[i].id] = this.consultantList[i].name;
          }

          // performanceTarget json化
          for (let i = 0; i < this.consultantList.length; i++) {
            if (this.consultantList[i].performanceTarget) {
              this.consultantList[i].performanceTarget = JSON.parse(this.consultantList[i].performanceTarget);
            } else {
              this.consultantList[i].performanceTarget = {};
            }
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        if (loading) {
          loading.close();
        }
      }
    },
    // 获取顾问全部时间的日期范围
    async getConsultantDateRange(showLoading = true) {
      //loading界面
      const loading = showLoading ? ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      }) : null;
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/consultantPerformance/getConsultantDateRange", params);
        if (resp1.data.code == "0000") {
          this.consultantDateRange = resp1.data.data;

          // console.log("this.consultantDateRange:", this.consultantDateRange);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        if (loading) {
          loading.close();
        }
      }
    },
    async drawChart1() {
      var chartDom = document.getElementById("chart1");
      if (!chartDom) {
        return;
      }
      var myChart = echarts.init(chartDom);
      let totalPerformance = 0;
      for (let consultantId in this.consultantPerformance) {
        totalPerformance += this.consultantPerformance[consultantId];
      }

      // console.log("totalPerformance:", totalPerformance);
      // 分母不能为0
      if (totalPerformance == 0) {
        totalPerformance = 1;
      }

      // 每个顾问百分比
      let data = [];
      for (let consultantId in this.consultantPerformance) {
        data.push({
          name: this.consultantNames[consultantId],
          value: (this.consultantPerformance[consultantId] * 100 / totalPerformance).toFixed(2)
        });
      }
      // data根据value排序
      data.sort(function (a, b) {
        return b.value - a.value;
      });
      this.performancePercentage = data;

      //如果顾问数量超过10个，再用随机颜色
      if (data.length > 10) {
        // 为每个项生成一个协调的随机颜色
        let colors = randomColor({
          count: data.length - 10,
          luminosity: "light",
          // 可选：'bright' | 'light' | 'dark'
          format: "hex"
        });
        this.colors.push(...colors);
      }
      const option = {
        color: this.colors,
        // legend: {
        //   show: true,
        //   data: ["王老师", "林老师", "张老师", "刘老师"],
        //   formatter: function (name) {
        //     // 获取对应数据的百分比
        //     const value = getDataByName(name);
        //     return name + " " + value + "%";
        //   },
        //   textStyle: {
        //     color: "#333",
        //   },
        // },
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b}: {c} ({d}%)",
        // },
        series: [{
          name: "老师分布",
          type: "pie",
          radius: "85%",
          center: ["50%", "50%"],
          data: data,
          labelLine: {
            show: false // 隐藏标签线
          },
          label: {
            show: false,
            // 标签文字不要
            position: "outside",
            // 标签位置（可选）
            formatter: "{b}: {d}%" // 标签内容格式
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      myChart.setOption(option);

      // console.log("this.colors:", this.colors);
    },
    // 日期范围变化，重新获取交费记录
    async dateRangeChange() {
      console.log("选择的日期范围:", this.dateRange);
      // 在这里可以根据选择的日期范围进行相应的处理，例如过滤数据等

      await this.getPaymentRecords();
    },
    search() {
      if (this.searchStr == "") {
        this.paymentRecords = this.oriPaymentRecords;
        return;
      }
      this.paymentRecords = [];
      for (let i = 0; i < this.oriPaymentRecords.length; i++) {
        if (this.oriPaymentRecords[i].className == null && this.oriPaymentRecords[i].payRemark == "金额异动") {
          this.oriPaymentRecords[i].className = "金额异动缴费";
        }
        if (this.oriPaymentRecords[i].className == null && this.oriPaymentRecords[i].payRemark == null) {
          this.oriPaymentRecords[i].className = "预存";
        }

        // if (!this.oriPaymentRecords[i].studentName) {
        //   console.log("this.oriPaymentRecords[i]:", this.oriPaymentRecords[i]);
        // }
        // if (!this.oriPaymentRecords[i].className) {
        //   console.log("this.oriPaymentRecords[i]:", this.oriPaymentRecords[i]);
        // }
        // if (!this.oriPaymentRecords[i].consultantName) {
        //   console.log("this.oriPaymentRecords[i]:", this.oriPaymentRecords[i]);
        // }

        // 如果搜索字符串在这三个字段中任意一个出现，就显示该记录
        if (this.oriPaymentRecords[i].studentName.includes(this.searchStr) || this.oriPaymentRecords[i].className && this.oriPaymentRecords[i].className.includes(this.searchStr) || this.oriPaymentRecords[i].consultantName.includes(this.searchStr)) {
          this.paymentRecords.push(this.oriPaymentRecords[i]);
        }
      }
    },
    // 点击div展开选择月份
    selectMonth() {
      // 通过 ref 获取 el-date-picker 实例
      const datePicker = this.$refs.monthDatePickerRef;
      // console.log("datePicker:", datePicker);
      if (datePicker) {
        // 调用 focus 方法展开日期选择器
        datePicker.focus();
      }
    },
    // 月份变化，重新获取顾问业绩
    async selectedMonthChange() {
      console.log("选择的月份:", this.selectedMonth);
      this.selectAllTime = false;
      await this.getConsultantPerformance(false);
      await this.drawChart1();
    },
    // 导出交费记录excel
    downloadPaymentRecords() {
      try {
        // 准备导出数据
        const exportData = [];

        // 添加表头
        exportData.push(["交费时间", "学生姓名", "来源渠道", "实际缴费", "现金价值", "报名班级", "校区", "支付方式", "顾问", "备注"]);

        // 遍历数据并添加到导出数组中
        for (let index in this.paymentRecords) {
          const item = this.paymentRecords[index];
          if (item.className == null && item.payRemark == "金额异动") {
            item.className = "金额异动缴费";
          }
          if (item.className == null && item.payRemark == null) {
            item.className = "预存";
          }
          exportData.push([item.create_time, item.studentName, item.customer_source, item.realPay, item.amount, item.className, item.campus, item.payMethod, item.consultantName, item.remark]);
        }

        // 创建工作簿
        const ws = XLSX.utils.aoa_to_sheet(exportData);

        // 设置列宽
        ws["!cols"] = [{
          wch: 25
        }, {
          wch: 15
        }, {
          wch: 15
        }, {
          wch: 15
        }, {
          wch: 15
        }, {
          wch: 30
        }, {
          wch: 15
        }, {
          wch: 15
        }, {
          wch: 15
        }, {
          wch: 60
        }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "交费记录");

        // 导出文件
        const fileName = `交费记录_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
        XLSX.writeFile(wb, fileName);
        console.log("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        alert("导出失败: " + error.message);
      }
    }
  }
};